import {
  ADD_TRANSACTION,
  ADD_PHYSICAL_TRANSACTION,
  GET_ALL_TRANSACTION,
  GET_ALL_TRANSATIONS_FROM_USER_ID,
  GET_PARTICULAR_TRANSACTION,
  GET_USER_EARNING_FROM_USER_ID,
} from "./actionTypes";
import { call, put, take, takeEvery, takeLatest } from "redux-saga/effects";
import {
  addTransactionFail,
  addTransactionSuccess,
  getAlltransactionFail,
  addPhysicalTransactionSuccess,
  addPhysicalTransactionFail,
  getAlltransactionSuccess,
  getParticulartransactionFail,
  getParticulartransactionSuccess,
  getTransactionFromUserIdFail,
  getTransactionFromUserIdSuccess,
  getUserEarningFromUserIdFail,
  getUserEarningFromUserIdSuccess,
} from "./actions";
import {
  addTransactionApi,
  fetchTransactionApi,
  getAllTransactionApi,
  getAllTransactionFromUserIdApi,
  getUserEarningFromUserIdApi,
  addPhysicalTransactionApi,
} from "helpers/backend_helper";
import moment from "moment";
function* fetchTransaction({ payload: { data, callback } }) {
  try {
    const response = yield call(fetchTransactionApi, data);

    if (response.status === "failure") {
      return yield put(getParticulartransactionFail(response.message));
    }

    callback && callback(response);
    yield put(getParticulartransactionSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(getParticulartransactionFail(error));
  }
}
function* addTransaction({ payload: { data, callback } }) {
  try {
    const response = yield call(addTransactionApi, data);

    if (response.status === "failure") {
      return yield put(addTransactionFail(response.message));
    }

    callback && callback(response);
    yield put(addTransactionSuccess(response.data));
  } catch (error) {
    console.log("error", error);
    yield put(addTransactionFail(error));
  }
}

function* addPhysicalTransactionSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(addPhysicalTransactionApi, data);
    if (response.status === "failure") {
      yield put(addPhysicalTransactionFail(response.message));
      return;
    }
    callback && callback(response);
    yield put(addPhysicalTransactionSuccess(response.data));
  } catch (error) {
    console.error("addPhysicalTransactionSaga error:", error);
    yield put(addPhysicalTransactionFail(error));
  }
}

function* getAllTransaction({ payload: { data, callback } }) {
  try {
    const response = yield call(getAllTransactionApi, data);

    if (response.status === "failure") {
      return yield put(getAlltransactionFail(response.message));
    } else {
      response.data.map((tr) => {
        let localtime = moment.unix(tr.created_date).local();
        tr.created_date = localtime.format("YYYY-MM-DD HH:mm:ss");
        return tr;
      });

      callback && callback(response);
      yield put(getAlltransactionSuccess(response));
    }
  } catch (error) {
    console.log("error", error);
    yield put(getAlltransactionFail(error));
  }
}

function* getAllTransactionFromUserId({ payload: { data, callback } }) {
  try {
    const response = yield call(getAllTransactionFromUserIdApi, data);
    if (response.status === "failure") {
      return yield put(getTransactionFromUserIdFail(response.message));
    } else {
      response.data.sort((a, b) => b._sortDate - a._sortDate);
    }

    callback && callback(response);
    yield put(getTransactionFromUserIdSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(getTransactionFromUserIdFail(error));
  }
}

function* getUserEarningFromUserId({ payload: { data, callback } }) {
  try {
    const response = yield call(getUserEarningFromUserIdApi, data);
    if (response.status === "failure") {
      return yield put(getUserEarningFromUserIdFail(response.message));
    }
    callback && callback(response);
    yield put(getUserEarningFromUserIdSuccess(response));
  } catch (error) {
    console.log("error", error);
    yield put(getUserEarningFromUserIdFail(error));
  }
}

function* OwnersSaga() {
  yield takeEvery(GET_PARTICULAR_TRANSACTION, fetchTransaction);
  yield takeEvery(ADD_TRANSACTION, addTransaction);
  yield takeLatest(GET_ALL_TRANSACTION, getAllTransaction);
  yield takeLatest(
    GET_ALL_TRANSATIONS_FROM_USER_ID,
    getAllTransactionFromUserId
  );
  yield takeLatest(GET_USER_EARNING_FROM_USER_ID, getUserEarningFromUserId);
  yield takeEvery(ADD_PHYSICAL_TRANSACTION, addPhysicalTransactionSaga);
}

export default OwnersSaga;
